import { RetailerClientState } from '../../reducers/retailer-client/RetailerClientReducer';
import { RetailerClientTypes } from '../Type';

export const updateRetailerClient = (payload: RetailerClientState) => {
  return (dispatch: any) => {
    dispatch({
      type: RetailerClientTypes.RetailerClientUpdate,
      payload,
    });
  };
};
